'use strict';

var ItemView = require('base/Colido.ItemView');

var template = require('modules/collection/modules/set/templates/partials/list-empty.hbs');

/**
 * View for rendering a single set
 *
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */
var EmptyView = ItemView.extend({
    template: template,
    className: 'empty-hint',
});

module.exports = EmptyView;